import React from 'react';
import ServiceCard from './ServiceCard';
import img1 from '../../../public/images/Accounting.png';
import img2 from '../../../public/images/Labor.png';
import img3 from '../../../public/images/Tax.png';
import Button from '../Button';

const Services = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">
      <div className="w-full lg:w-3/4 space-y-8">
        <ServiceCard
          img={img1}
          title="Outsourcing Contable"
          description="En Sicons Peru le brindamos el apoyo que necesita para elaborar su contabilidad de acuerdo con los requerimientos locales y conforme a las Normas Internacionales de Información Financiera (NIIF)."
          items={[
            "Procesamiento mensual de la información contable para el cumplimiento de obligaciones tributarias.",
            "Elaboración de estados financieros.",
            "Elaboración de informes y reportes contables.",
            "Reportes corporativos."
          ]}
        />
        <ServiceCard
          img={img2}
          title="Outsourcing Laboral"
          description="Nos encargamos de preparar la planilla, administrando óptimamente la privacidad y confidencialidad de los datos que requiere su empresa."
          items={[
            "Proceso mensual de nóminas",
            "Carga y administración de empleados a T-registro.",
            "Declaración del Plame ante la Administración Tributaria",
            "Asientos y provisiones de nóminas.",
            "Liquidaciones de beneficios sociales.",
            "Cálculo de gratificaciones, CTS, vacaciones y utilidades anuales.",
            "Auditorías de nóminas.",
            "Cumplimiento de obligaciones ante la autoridad laboral y AFP."
          ]}
          reverse
        />
        <ServiceCard
          img={img3}
          title="Outsourcing Tributario"
          description="Nuestra experiencia nos permite brindar servicios, tanto para la planificación de sus operaciones como para la solución de controversias de índole tributaria, derivadas de procesos de fiscalización."
          items={[ // Pasa los items como un array
            "Consultoría y auditoría tributaria.",
            "Planeamiento tributario y optimización de obligaciones tributarias.",
            "Asesoría en procedimientos de devolución de tributos.",
            "Asesoría en la aplicación deConvenios para Evitar la Doble Imposición suscritos por el Perú.",
            "Atención de fiscalizaciones tributarias.",
            "Revisión y cumplimiento de obligaciones tributarias de carácter mensual y anual.",
            "Impresión de libros oficiales y/o presentación de libros electrónicos."
          ]}
        />
      </div>

{/*       <Button title="Ver Todos los Servicios" /> */}
    </div>
  );
};

export default Services;
